var map = {
	"./amadeus/MasterDetail.json": 1190,
	"./barclays/MasterDetail.json": 1191,
	"./cb911/MasterDetail.json": 1192,
	"./choiceHotels/MasterDetail.json": 1193,
	"./globex/MasterDetail.json": 1194,
	"./kraken/MasterDetail.json": 1195,
	"./lastminute/MasterDetail.json": 1196,
	"./monavate/MasterDetail.json": 1197,
	"./outpayce/MasterDetail.json": 1198,
	"./sofi/MasterDetail.json": 1199
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1189;